export const CheckoutFormInputStyles = {
  '.chakra-form__label': {
    fontSize: '12px',
    fontWeight: '400',
    color: 'black',
  },
  '.chakra-form__error-message': {
    fontSize: '12px',
    fontWeight: '400',
    color: 'danger.400',
  },
  '.chakra-input': {
    fontSize: '16px',
    fontWeight: '400',
    color: 'black',
    borderColor: 'black',
    '&:focus': {
      borderColor: 'primary.200',
    },
    '&:hover': {
      borderColor: 'base.100',
    },
  },
};
